import React, { useMemo } from 'react';
import styled from '../../../../styled';
import Text from '../../../text';
import dayjs, { TODAY } from '../day';
import { Column, ColumnButton } from './Column';
const WeekdayColumn = styled(Column) `
  color: ${({ theme }) => theme.colors.INK_500};
  width: 2.25rem;
  height: 2.25rem;
  font-weight: 600;
`;
const DateColumn = styled(ColumnButton) `
  width: 2.25rem;
  height: 2.25rem;
  margin-bottom: 0.25rem;
`;
const DateContainer = styled.div `
  > ${DateColumn}:first-of-type {
    margin-left: ${({ offset }) => offset * 2.25}rem;
  }
`;
const DateCalendarView = ({ lang, target, selectedDate, selectedFrom, selectedTo, onSelect, disabledDate, }) => {
    const dates = useMemo(() => new Array(target.daysInMonth()).fill(null).map((_, i) => i + 1), [target]);
    const offset = target.startOf('month').day();
    const weekdays = useMemo(() => dayjs(lang).localeData().weekdaysMin(), [lang]);
    return (React.createElement(React.Fragment, null,
        weekdays.map(weekdayLabel => (React.createElement(WeekdayColumn, { key: weekdayLabel },
            React.createElement(Text, { lang: lang, fontType: "Caption", color: "INK_500" }, weekdayLabel)))),
        React.createElement(DateContainer, { offset: offset }, dates.map((date) => {
            const targetDate = target.date(date);
            const isDisabled = disabledDate(targetDate.toDate());
            const isToday = targetDate.isSame(TODAY, 'date');
            const from = selectedFrom || selectedDate;
            const to = selectedTo || selectedDate;
            const isPeriod = from &&
                to &&
                targetDate.isBetween(from, to, 'date', '[]');
            const isSelected = !selectedFrom &&
                !selectedTo &&
                selectedDate &&
                targetDate.isSame(selectedDate, 'date');
            const isFromSelected = from && targetDate.isSame(from, 'date');
            const isToSelected = to && targetDate.isSame(to, 'date');
            const handleClick = () => onSelect(targetDate.clone());
            if (isDisabled) {
                return (React.createElement(DateColumn, { key: targetDate.toString(), isDisabled: true }, date.toString()));
            }
            return (React.createElement(DateColumn, { key: targetDate.toString(), isDefault: isToday, isSelected: isSelected, isFromSelected: isFromSelected, isToSelected: isToSelected, isPeriod: isPeriod, onClick: handleClick }, date.toString()));
        }))));
};
export default DateCalendarView;
//# sourceMappingURL=DateCalendarView.js.map